var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23047 10.3075C5.23047 10.7564 5.40877 11.1868 5.72613 11.5042C6.0435 11.8216 6.47395 11.9998 6.92278 11.9998C7.3716 11.9998 7.80205 11.8216 8.11942 11.5042C8.43679 11.1868 8.61508 10.7564 8.61508 10.3075C8.61508 9.85871 8.43679 9.42827 8.11942 9.1109C7.80205 8.79353 7.3716 8.61523 6.92278 8.61523C6.47395 8.61523 6.0435 8.79353 5.72613 9.1109C5.40877 9.42827 5.23047 9.85871 5.23047 10.3075Z",
    stroke: "black",
    strokeWidth: 1.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76923 5.23077L4.38462 1H1M7.76923 5.23077H8.61538C9.06421 5.23077 9.49466 5.40907 9.81203 5.72643C10.1294 6.0438 10.3077 6.47425 10.3077 6.92308V10.3077H8.61538M7.76923 5.23077H1M5.23077 10.3077H1M2.69231 5.23077V1M10.3077 2.69231V1M14.5385 6.07692H16.2308M13.2692 9.03846L14.5385 10.3077M13.2692 3.11538L14.5385 1.84615",
    stroke: "black",
    strokeWidth: 1.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.9bb919154ed99ce3356732ba805b84e3.svg";
export { ForwardRef as ReactComponent };